

















































import { Component, Vue, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';

@Component({
  components: {
    Typography,
    CloseModalIcon
  }
})
export default class MerchantIDTooltip extends Vue {
  @Prop({ default: 'signup' }) origin!: string;
  @Prop({ default: false }) viaTippy!: boolean;

  get tPrefix() {
    return 'common.components.merchantIDTooltip';
  }

  get isBusinessProfile() {
    return this.origin === 'business-profile';
  }
}
